export const formatApiErrorDetail = (detail: unknown, fallback = 'An error occurred'): string => {
  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  if (Array.isArray(detail)) {
    const messages = detail
      .map((item) => {
        if (!item || typeof item !== 'object') {
          return typeof item === 'string' ? item : '';
        }

        const validationError = item as { loc?: unknown; msg?: unknown };
        const message = typeof validationError.msg === 'string' ? validationError.msg : '';
        const location = Array.isArray(validationError.loc)
          ? validationError.loc.filter((part) => part !== 'query' && part !== 'body').join('.')
          : '';

        return [location, message].filter(Boolean).join(': ');
      })
      .filter(Boolean);

    return messages.length > 0 ? messages.join('; ') : fallback;
  }

  if (detail && typeof detail === 'object') {
    const message = (detail as { message?: unknown }).message;
    if (typeof message === 'string' && message.trim()) {
      return message;
    }
  }

  return fallback;
};
